import React, { useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import Editor from '../../../../../../../old/utils/tinymce';
import FieldLabel from './FieldLabel';

// Тексты нижнего блока хранятся как HTML и в старом редакторе правились визуальным
// редактором. Простой input показывал бы сырую разметку и затирал её при правке.
const toPlain = (html) => String(html || '')
  .replace(/<[^>]*>/g, ' ')
  .replace(/&nbsp;/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

function RichTextField({ label, value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [draft, setDraft] = useState(value || '');

  const preview = toPlain(value);

  const open = () => {
    setDraft(value || '');
    setIsOpen(true);
  };

  const apply = () => {
    onChange(draft);
    setIsOpen(false);
  };

  return (
    <div>
      <FieldLabel>{label}</FieldLabel>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '8px 12px',
          border: '1px solid #d9d9d9',
          borderRadius: 6,
          background: '#fafafa',
        }}
      >
        <Typography.Text
          type={preview ? undefined : 'secondary'}
          ellipsis
          style={{ flex: 1, minWidth: 0 }}
        >
          {preview || 'текст не задан'}
        </Typography.Text>
        <Button size="small" icon={<EditOutlined />} onClick={open}>
          Изменить
        </Button>
      </div>

      <Modal
        open={isOpen}
        title={label}
        width={900}
        okText="Готово"
        cancelText="Отмена"
        onOk={apply}
        onCancel={() => setIsOpen(false)}
        destroyOnClose
      >
        <Editor data={draft} setData={setDraft} minHeight={400} height={400} />
      </Modal>
    </div>
  );
}

export default RichTextField;
